(function () {
  'use strict';

  angular.module('app').service('BookingItemModalService', BookingItemModalService);

  BookingItemModalService.$inject = ['CONFIGURATIONS', 'ModalService', '$filter'];

  function BookingItemModalService(config, ModalService, $filter) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openBookingItemList: openBookingItemList,
      openBookingItemDetail: openBookingItemDetail,
      editBookingItemCost: editBookingItemCost,
      editBookingItemPrice: editBookingItemPrice,
      openBookingItemStandardCostBased: openBookingItemStandardCostBased,
      openBookingItemServiceItemsCostBased: openBookingItemServiceItemsCostBased,

      openSendBookingItemVoucherToClient: openSendBookingItemVoucherToClient,
      editBookingItemPickUpTime: editBookingItemPickUpTime,
    };

    return service;

    ////////////////////////

    // --------------------------- openBookingItemList -------------------------

    function openBookingItemList(bookingId) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/booking-items/modals/booking-item-list-modal.html',
        controller: BookingItemListCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingId: bookingId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      BookingItemListCtrl.$inject = ['bookingId', 'BookingService'];
    }

    function BookingItemListCtrl(bookingId, BookingService) {
      var vm = this;

      vm.modalTitle = 'BOOKING_DETAILS';

      // Initializers
      getBooking(bookingId);

      function getBooking(bookingId) {
        vm.loadingBooking = true;
        BookingService.getBooking(bookingId).then(function (data) {
          vm.booking = data;

          vm.loadingBooking = false;
        });
      }
    }

    // --------------------------- openBookingItemDetail -------------------------

    function openBookingItemDetail(
      productType,
      bookingItem,
      booking,
      documentDateExchangeRate,
      currencies,
      companyBaseCurrencyId,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/booking-items/modals/booking-item-detail-modal.html',
        controller: BookingItemDetailModalCtrl,
        controllerAs: 'vm',
        inputs: {
          productType: productType,
          bookingItem: bookingItem,
          booking: booking,
          documentDateExchangeRate: documentDateExchangeRate,
          currencies: currencies,
          companyBaseCurrencyId: companyBaseCurrencyId,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      BookingItemDetailModalCtrl.$inject = [
        '$element',
        'productType',
        'bookingItem',
        'booking',
        'documentDateExchangeRate',
        'currencies',
        'companyBaseCurrencyId',
        'successCallback',
      ];
    }

    function BookingItemDetailModalCtrl(
      $element,
      productType,
      bookingItem,
      booking,
      documentDateExchangeRate,
      currencies,
      companyBaseCurrencyId,
      successCallback
    ) {
      var vm = this;

      vm.productType = productType;
      vm.bookingItem = bookingItem;
      vm.booking = booking;
      vm.documentDateExchangeRate = documentDateExchangeRate;
      vm.currencies = currencies;
      vm.companyBaseCurrencyId = companyBaseCurrencyId;

      if (!vm.bookingItem.id) {
        vm.bookingItem = {
          adults: 2,
          children: 0,
          infants: 0,
          seniors: 0,
        };
      }

      // Methods
      vm.onBookingItemSaved = onBookingItemSaved;
      vm.onBookingItemCanceled = onBookingItemCanceled;

      function onBookingItemSaved(bookingItemObj) {
        $element.modal('hide');
        successCallback(bookingItemObj);
      }

      function onBookingItemCanceled() {
        $element.modal('hide');
      }
    }

    // --------------------------- editBookingItemCost -------------------------

    function editBookingItemCost(bookingItem, booking, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/booking-items/modals/booking-item-edit-cost-modal.html',
        controller: EditBookingItemCostCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      EditBookingItemCostCtrl.$inject = ['$element', 'bookingItem', 'booking', 'successCallback'];
    }

    function EditBookingItemCostCtrl($element, bookingItem, booking, successCallback) {
      const vm = this;

      vm.bookingItem = bookingItem;
      vm.booking = booking;

      // Methods
      vm.onBookingItemCostSaved = onBookingItemCostSaved;

      function onBookingItemCostSaved($bookingItem) {
        $element.modal('hide');
        successCallback($bookingItem);
      }
    }

    // --------------------------- editBookingItemPrice -------------------------

    function editBookingItemPrice(bookingItem, booking, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bookings/booking-items/modals/booking-item-edit-price-modal.html',
        controller: EditBookingItemPriceCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      EditBookingItemPriceCtrl.$inject = ['$element', 'bookingItem', 'booking', 'successCallback'];
    }

    function EditBookingItemPriceCtrl($element, bookingItem, booking, successCallback) {
      const vm = this;

      vm.bookingItem = bookingItem;
      vm.booking = booking;

      // Methods
      vm.onBookingItemPriceSaved = onBookingItemPriceSaved;

      function onBookingItemPriceSaved($bookingItem) {
        $element.modal('hide');
        successCallback($bookingItem);
      }
    }

    // --------------------------- openBookingItemStandardCostBased -------------------------

    function openBookingItemStandardCostBased(
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/modals/booking-item-standard-cost-based-modal.html',
        controller: OpenBookingItemStandardCostBasedCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          documentDateExchangeRate: documentDateExchangeRate,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      OpenBookingItemStandardCostBasedCtrl.$inject = [
        '$element',
        'bookingItem',
        'booking',
        'documentDateExchangeRate',
        'successCallback',
      ];
    }

    function OpenBookingItemStandardCostBasedCtrl(
      $element,
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
      // TaxService
    ) {
      var vm = this;

      vm.bookingItem = bookingItem;
      vm.booking = booking;
      vm.documentDateExchangeRate = documentDateExchangeRate;

      vm.dateDisplay = config.DATE_DISPLAY;
      vm.hourDisplay = config.HOUR_DISPLAY;

      vm.onBookingItemStandardCostBasedSaved = (bookingItemObj) => {
        $element.modal('hide');
        successCallback(bookingItemObj);
      };

      vm.onBookingItemServiceItemsCostBasedSaved = (bookingItemObj) => {
        $element.modal('hide');
        successCallback(bookingItemObj);
      };
    }

    // ------------------ openBookingItemServiceItemsCostBased ----------------

    function openBookingItemServiceItemsCostBased(
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/modals/booking-item-service-items-cost-based-modal.html',
        controller: OpenBookingItemServiceItemsCostBasedCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          documentDateExchangeRate: documentDateExchangeRate,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      OpenBookingItemServiceItemsCostBasedCtrl.$inject = [
        '$element',
        'bookingItem',
        'booking',
        'documentDateExchangeRate',
        'successCallback',
      ];
    }

    function OpenBookingItemServiceItemsCostBasedCtrl(
      $element,
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      var vm = this;

      vm.bookingItem = bookingItem;
      vm.booking = booking;
      vm.documentDateExchangeRate = documentDateExchangeRate;

      vm.costBasedTypes = config.COST_BASED_TYPES;
      vm.dateDisplay = config.DATE_DISPLAY;
      vm.hourDisplay = config.HOUR_DISPLAY;

      vm.onBookingItemServiceItemsCostBasedSaved = (bookingItemObj) => {
        $element.modal('hide');
        successCallback(bookingItemObj);
      };

      vm.onBookingItemStandardCostBasedSaved = (bookingItemObj) => {
        $element.modal('hide');
        successCallback(bookingItemObj);
      };
    }

    // --------------------------- openSendBookingItemVoucherToClient -------------------------

    function openSendBookingItemVoucherToClient(bookingItem, booking, successCallback) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/modals/send-booking-item-voucher-to-client-modal.html',
        controller: SendBookingItemVoucherToClientCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SendBookingItemVoucherToClientCtrl.$inject = [
        '$element',
        'bookingItem',
        'booking',
        'successCallback',
        'BookingItemService',
      ];
    }

    function SendBookingItemVoucherToClientCtrl(
      $element,
      bookingItem,
      booking,
      successCallback,
      BookingItemService
    ) {
      var vm = this;

      vm.clientEmail = angular.copy(booking.client.email);

      // Methods
      vm.sendBookingItemVoucher = sendBookingItemVoucher;

      function sendBookingItemVoucher(isFormValid) {
        if (!isFormValid) {
          return;
        }

        vm.sendingForm = true;
        BookingItemService.sendBookingItemVoucherToClient(
          bookingItem.id,
          bookingItem.booking_id,
          booking.company_id,
          vm.clientEmail
        ).then(function (data) {
          $element.modal('hide');
          successCallback(data);

          vm.sendingForm = false;
        });
      }
    }

    function editBookingItemPickUpTime(bookingItem, booking, successCallback) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/modals/booking-item-edit-pick-up-time-modal.html',
        controller: editBookingItemPickUpTimeCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItem: bookingItem,
          booking: booking,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      editBookingItemPickUpTimeCtrl.$inject = [
        '$element',

        'bookingItem',
        'booking',
        'successCallback',
      ];
    }

    function editBookingItemPickUpTimeCtrl(
      $element,

      bookingItem,
      booking,
      successCallback
    ) {
      const vm = this;

      vm.bookingItem = bookingItem;
      vm.booking = booking;

      // Methods
      vm.onBookingItemPickUpTimeSaved = onBookingItemPickUpTimeSaved;

      function onBookingItemPickUpTimeSaved($bookingItem) {
        $element.modal('hide');

        $bookingItem.pickup_time = $filter('date')($bookingItem.pickup_time, 'HH:mm');

        successCallback($bookingItem);
      }
    }
  }
})();
